import './MemberNotes.scss';
import { RootState } from '../../../../store/store';
import { useDispatch, useSelector } from 'react-redux';
import { openNotesModal } from '../../../../store/memberSlice';

const MemberNotes = () => {
  const dispatch = useDispatch();
  const assigned_doctor = JSON.parse(sessionStorage.getItem("assigned_doctor") ?? "false");
  const { admin: { role } } = useSelector((state: RootState) => state.admin);
  const visible = ((role !== "doctor") || (assigned_doctor && role === "doctor"));

  return (
    <div className='member-notes-container'>
      {visible && (
        <div className='member-notes-header-container'>
          <div>
            <div className='notes-header'>
              <span>Notes</span>
            </div>
            <div className='notes-sub-header'>
              Member doesn't see these notes
            </div>
          </div>
          <div
            className='add-note-btn'
            onClick={() => {
              dispatch(openNotesModal());
            }}
          >
            Add Note
          </div>
        </div>
      )}
    </div>
  );
};

export default MemberNotes;
